import GridOff from '@mui/icons-material/GridOff';
import { ButtonGroup, Divider } from '@mui/material';

import {
  DeleteColumn,
  DeleteRow,
  InsertColumnLeft,
  InsertColumnRight,
  InsertRowBottom,
  InsertRowTop,
  LayoutColumnFill,
  LayoutRowFill,
  MergeCellsHorizontal,
  SplitCellsHorizontal,
} from './icons';
import { TooltipButton } from 'components/generic/TooltipButton';
import { useEditorBubbleMenu } from '../../context';

const TableBubbleButtons = () => {
  const { editor } = useEditorBubbleMenu();

  if (!editor) return null;

  return (
    <ButtonGroup
      size="small"
      variant="contained"
      color="primary"
      aria-label="bubble-menu"
      disableElevation
      sx={{
        backgroundColor: 'primary.main',
        '& .MuiButtonBase-root': {
          borderRadius: 0,
        },
        '& .MuiSvgIcon-root': {
          color: 'primary.contrastText',
        },
      }}
    >
      <TooltipButton
        title="Insert column before"
        onClick={() => editor?.chain().focus().addColumnBefore().run()}
        Icon={InsertColumnLeft}
        disabled={!editor?.can().addColumnBefore()}
      />
      <TooltipButton
        title="Insert column after"
        onClick={() => editor?.chain().focus().addColumnAfter().run()}
        Icon={InsertColumnRight}
        disabled={!editor?.can().addColumnAfter()}
      />
      <TooltipButton
        title="Delete column"
        onClick={() => editor?.chain().focus().deleteColumn().run()}
        Icon={DeleteColumn}
        disabled={!editor?.can().deleteColumn()}
      />
      <Divider
        orientation="vertical"
        flexItem
      />
      <TooltipButton
        title="Insert row before"
        onClick={() => editor?.chain().focus().addRowBefore().run()}
        Icon={InsertRowTop}
        disabled={!editor?.can().addRowBefore()}
      />
      <TooltipButton
        title="Insert row after"
        onClick={() => editor?.chain().focus().addRowAfter().run()}
        Icon={InsertRowBottom}
        disabled={!editor?.can().addRowAfter()}
      />
      <TooltipButton
        title="Delete row"
        onClick={() => editor?.chain().focus().deleteRow().run()}
        Icon={DeleteRow}
        disabled={!editor?.can().deleteRow()}
      />
      <Divider
        orientation="vertical"
        flexItem
      />
      <TooltipButton
        title="Merge cells"
        onClick={() => editor?.chain().focus().mergeCells().run()}
        Icon={MergeCellsHorizontal}
        disabled={!editor?.can().mergeCells()}
      />
      <TooltipButton
        title="Split cells"
        onClick={() => editor?.chain().focus().splitCell().run()}
        Icon={SplitCellsHorizontal}
        disabled={!editor?.can().splitCell()}
      />
      <Divider
        orientation="vertical"
        flexItem
      />
      <TooltipButton
        title="Toggle Header Column"
        onClick={() => editor?.chain().focus().toggleHeaderColumn().run()}
        Icon={LayoutColumnFill}
        disabled={!editor?.can().toggleHeaderColumn()}
      />
      <TooltipButton
        title="Toggle Header Row"
        onClick={() => editor?.chain().focus().toggleHeaderRow().run()}
        Icon={LayoutRowFill}
        disabled={!editor?.can().toggleHeaderRow()}
      />
      <Divider
        orientation="vertical"
        flexItem
      />
      <TooltipButton
        title="Delete Table"
        onClick={() => editor?.chain().focus().deleteTable().run()}
        Icon={GridOff}
        disabled={!editor?.can().deleteTable()}
      />
    </ButtonGroup>
  );
};

export default TableBubbleButtons;
